import { convertToNumber } from '@/utils/common';

export class SearchApiKeyDto {
  constructor(data) {
    this.name = data.name || null;
    this.partnerName = data.partnerName || null;
    this.partnerCode = data.partnerCode || null;
    this.apiKey = data.apiKey || null;
    this.page = convertToNumber({
      value: data.page,
      defaultValue: 1,
    });
    this.size = convertToNumber({
      value: data.size,
      defaultValue: 10,
    });
  }
}
